import { takeLatest, put } from 'redux-saga/effects';

import * as actions from './actions';
import * as types from './types';

function* initRequest() {
  yield put(actions.init());
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

export default [
  watchInitRequest,
];
